import FolderContent from './FolderContent';
import FolderContentContainer from './FolderContent.container';
export default FolderContentContainer(FolderContent);
//# sourceMappingURL=index.js.map